@if (manager) {
  <div class="content desktop-not-member-contribute">
    <div class="join-not-a-member-header">
      <div class="widget-header">
        @if (manager.open_syndicates_number <= 1) {
          <span [transloco]="'widgetCaptainSyndicates.TITLE_SINGLE'" [translocoParams]="{manager: manager.username, count: manager.open_syndicates_number}"></span>
        } @else {
          <span [transloco]="'widgetCaptainSyndicates.TITLE_MULTI'" [translocoParams]="{manager: manager.username, count: manager.open_syndicates_number}"></span>
        }
      </div>
      <div class="position-fix">
        <img class="avatar-img" [src]="manager.picture_url" imgLazyLoad [alt]="manager?.username">
        <div class="tag xsell">
          {{manager.open_syndicates_number}}
        </div>
      </div>
    </div>
    <a class="btn primary w-button" [routerLink]="['/', 'syndicates', 'manager', manager.id]">
      <span [transloco]="'buttons.VIEW_AVAILABLE_SYNDICATES'"></span>
    </a>
  </div>
}
